import { useState } from 'react';
import { useDispatch } from 'react-redux';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Button from '@components/Button';
import { useTranslation, trackExport } from '@hooks';
import { handleApiError } from '@helpers/api';
import { downloadBlobAs } from '@helpers/download';
import { alertActions } from '@actions';

const ExportCSV = ({ callback, type, sx = {} }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onExport = async () => {
        setIsSubmitting(true);
        try {
            const response = await callback();
            if (response?.exportStatusId) {
                trackExport(response.exportStatusId);
                dispatch(
                    alertActions.success(t('exports.exporting'), { id: response.exportStatusId, persistent: true }),
                );
            } else if (typeof response === 'string') {
                downloadBlobAs(response, `${type}.csv`);
            }
        } catch (error) {
            handleApiError(error, 'common.exportError');
        }
        setIsSubmitting(false);
    };

    return (
        <Button
            variant="outlined"
            style={{ flexShrink: 0 }}
            startIcon={<FileDownloadIcon sx={{ height: '18px !important', width: '18px !important' }} />}
            onClick={onExport}
            disabled={isSubmitting}
            sx={sx}
        >
            {t('buttons.exportAsCSV')}
        </Button>
    );
};

export default ExportCSV;
